import { createSlice } from "@reduxjs/toolkit";
import { showToast } from "../../../components/Toast";
import { handleSendOtp } from "./apiThunk";

const authenticationSlice = createSlice({
  name: "authentication",
  initialState: {
    login: {
      mobileNo: "",
    },
    userData: {}
  },
  reducers: {
    updatelogin: (state: any, action: any) => {
      state.login = action.payload;
    },
    updateUserData: (state: any, action: any) => {
      state.userData = action.payload;
    },
    resetLogin: (state: any) => {
      state.login = {
        mobileNo: "",
      };
      state.userData = {};
    },
  },
  extraReducers: (builder: any) => {
   
  },
});

const { reducer } = authenticationSlice;
const selectorAuthentication = (state: any) => state.authentication;
const { updatelogin, updateUserData, resetLogin } = authenticationSlice.actions;
export { updatelogin, updateUserData, resetLogin, selectorAuthentication };

export default reducer;
